import { render, staticRenderFns } from "./index.vue?vue&type=template&id=274a0066"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=274a0066&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274a0066')) {
      api.createRecord('274a0066', component.options)
    } else {
      api.reload('274a0066', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=274a0066", function () {
      api.rerender('274a0066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/frame/index.vue"
export default component.exports